// Tutorial-specific cards with deterministic IDs for targeting
import type { Card, Artist } from '../types/game'

/**
 * Player's hand - 6 cards with variety of artists and auction types
 */
export const TUTORIAL_CARDS: Record<string, Card> = {
  yokoHidden: {
    id: 'tutorial-card-0',
    artist: 'Solstice Vane',
    auctionType: 'hidden',
    artworkId: 'manuel_carvalho_hidden_1',
    cardIndex: 0,
  },
  sigridOneOffer: {
    id: 'tutorial-card-1',
    artist: 'Mira Faux',
    auctionType: 'one_offer',
    artworkId: 'sigrid_thaler_one_offer_1',
    cardIndex: 0,
  },
  manuelOpen: {
    id: 'tutorial-card-2',
    artist: 'Solstice Vane',
    auctionType: 'open',
    artworkId: 'manuel_carvalho_open_1',
    cardIndex: 1,
  },
  danielFixed: {
    id: 'tutorial-card-3',
    artist: 'Atlas Zero',
    auctionType: 'fixed_price',
    artworkId: 'daniel_melim_fixed_price_1',
    cardIndex: 0,
  },
  ramonDouble: {
    id: 'tutorial-card-4',
    artist: 'Vesper Kint',
    auctionType: 'double',
    artworkId: 'ramon_martins_double_1',
    cardIndex: 0,
  },
  rafaelOpen: {
    id: 'tutorial-card-5',
    artist: 'Luxe Nebula',
    auctionType: 'open',
    artworkId: 'rafael_silveira_open_1',
    cardIndex: 0,
  },
}

/**
 * Cards for AI opponents (Alice and Bob)
 */
export const ALICE_CARDS: Card[] = [
  {
    id: 'alice-card-0',
    artist: 'Solstice Vane',
    auctionType: 'one_offer',
    artworkId: 'manuel_carvalho_one_offer_1',
    cardIndex: 2,
  },
  {
    id: 'alice-card-1',
    artist: 'Mira Faux',
    auctionType: 'open',
    artworkId: 'sigrid_thaler_open_1',
    cardIndex: 1,
  },
  {
    id: 'alice-card-2',
    artist: 'Atlas Zero',
    auctionType: 'hidden',
    artworkId: 'daniel_melim_hidden_1',
    cardIndex: 1,
  },
  {
    id: 'alice-card-3',
    artist: 'Vesper Kint',
    auctionType: 'open',
    artworkId: 'ramon_martins_open_1',
    cardIndex: 1,
  },
  {
    id: 'alice-card-4',
    artist: 'Luxe Nebula',
    auctionType: 'one_offer',
    artworkId: 'rafael_silveira_one_offer_1',
    cardIndex: 1,
  },
  {
    id: 'alice-card-5',
    artist: 'Solstice Vane',
    auctionType: 'fixed_price',
    artworkId: 'manuel_carvalho_fixed_price_1',
    cardIndex: 3,
  },
]

export const BOB_CARDS: Card[] = [
  {
    id: 'bob-card-0',
    artist: 'Mira Faux',
    auctionType: 'fixed_price',
    artworkId: 'sigrid_thaler_fixed_price_1',
    cardIndex: 2,
  },
  {
    id: 'bob-card-1',
    artist: 'Atlas Zero',
    auctionType: 'open',
    artworkId: 'daniel_melim_open_1',
    cardIndex: 2,
  },
  {
    id: 'bob-card-2',
    artist: 'Vesper Kint',
    auctionType: 'one_offer',
    artworkId: 'ramon_martins_one_offer_1',
    cardIndex: 2,
  },
  {
    id: 'bob-card-3',
    artist: 'Luxe Nebula',
    auctionType: 'hidden',
    artworkId: 'rafael_silveira_hidden_1',
    cardIndex: 2,
  },
  {
    id: 'bob-card-4',
    artist: 'Solstice Vane',
    auctionType: 'double',
    artworkId: 'manuel_carvalho_double_1',
    cardIndex: 4,
  },
  {
    id: 'bob-card-5',
    artist: 'Mira Faux',
    auctionType: 'double',
    artworkId: 'sigrid_thaler_double_1',
    cardIndex: 3,
  },
]
